<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <app-base-main parentTable>
        <template #filter-group>
            <app-filter-group
                    @query="$gjNoticeQuery"
                    @reset="$gjReset">

                <gj-market-select
                        v-model="filter.marketIds"
                        multiple
                        width="170px"
                        placeholder="请选择店铺"
                ></gj-market-select>

                <gj-date-picker
                        v-model="filter.month"
                        type="month"
                        placeholder="选择月"/>
                <gj-select-input
                        v-model="filter.keyword"
                        :options="[
                       {id: 'msku', text: 'MSKU'},
                       {id: 'asin', text: 'ASIN'},
                       {id: 'fnsku', text: 'FNSKU'}
                   ]"
                >
                </gj-select-input>

                <gj-category-select
                        v-model="filter.categoryIds"
                        placeholder="品类"
                        multiple
                        active
                ></gj-category-select>

                <gj-brand-select
                        v-model="filter.brandIds"
                        placeholder="品牌"
                        multiple
                        collapse-tags
                        active
                        width="170px"
                ></gj-brand-select>

                <template #right>
                    <gj-tool-group
                            setting :table-name="tableName"
                            :table-columns="columns"
                            :sort-gjtable="$refs.gjTable"
                            :download="$permission('storageFee:export')"
                            download-url="/operation/storageFee/export"
                            :download-params="globalParams"
                            help
                    >
                    </gj-tool-group>
                </template>
            </app-filter-group>
        </template>
        <template #table>
            <gj-table
                    ref="gjTable"
                    adaptParent
                    :name="tableName"
                    :data="tableData"
                    :columns="columns"
                    :loading="loading"
                    sortable="custom"
                    :show-overflow="false"
                    :default-sort="{prop: 'impressions', order: 'descending'}"
                    :size="'has-picture'"
                    :pagination="pagination"
                    @sort-change="$gjSortChange"
                    @page-change="$gjNoticeQuery">
              <template v-slot:asin="{row}">
                <el-row>
                  <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                  <gj-copy-icon v-if="isMeaningful(row.asin)" :content="row.asin"/>
                </el-row>
              </template>
                <template v-slot:msku="{row}">
                    <div>
                        <div class="text-ellipsis-1">{{row.fnsku}}</div>
                        <div class="text-ellipsis-1">{{row.msku}}</div>
                    </div>
                </template>
            </gj-table>
        </template>
    </app-base-main>

</template>

<script>
    import {queryMixin, isMeaningfulMixin} from "../../../../minxins";
    import {isMeaningful} from "../../../../utils/common";
    import {exportStorageFee, getStorageFeePage} from "../../../../api/statistics";
    import {convertToMonth} from "../../../../utils/date.util";

    export default {
        name: "app-storageFee",
        mixins: [queryMixin, isMeaningfulMixin],
        components: {},
        data() {
            return {
                tableName: 'storageFee',
                columns: [
                    // id: 字段ID，用于优化渲染以及自定义列，必填
                    // header: 表头名称结构为：slot:slotName:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
                    // field: 字段内容域，类型为数据字段名或slot
                    // help: 帮助信息（问号）
                    // notCustomColumn: 是否是自定义字段，默认：false
                    // default: 是否自定义列默认字段
                    {id: 'marketName', header: '店铺/国家', field: 'marketName', minWidth: '120px', default: true, fixed: 'left', disabled: true},
                    {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', minWidth: '60px', default: true, fixed: 'left', disabled: true},
                    {id: 'asin', header: 'ASIN', field: 'slot:asin', fixed: 'left', minWidth: '140px', default: true, sortable: true,disabled: true},
                    {id: 'msku', header: 'MSKU', field: 'msku', fixed: 'left', minWidth: '140px', default: true, sortable: true,disabled: true, copyable:true},
                    {id: 'productName', header: '商品标题', field: 'productName',fixed: 'left',  minWidth: '150px', default: true, overflowLine: 1, disabled: true},
                   // {id: 'asin', header: '商品标题/ASIN/MSKU', field: 'slot:asin', minWidth: '300px', default: true, fixed: 'left', disabled: true},
                    {id: 'fnsku', header: 'FNSKU', field: 'fnsku', minWidth: '110px', default: true,sortable: true},
                    {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '80px', default: true},
                    {id: 'brandName', header: '品牌', field: 'brandName', minWidth: '100px', default: true},
                    {id: 'month', header: '月份', field: 'month', minWidth: '80px', default: true},
                    {
                        id: 'fulfillmentCenter',
                        header: '亚马逊仓库代码',
                        field: 'fulfillmentCenter',
                        minWidth: '110px',
                        default: true
                    },
                    {id: 'countryCode', header: '国家', field: 'countryCode', minWidth: '60px', default: true},
                    {
                        id: 'longestSide',
                        header: '长边',
                        field: 'longestSide',
                        minWidth: '80px',
                        sortable: true,
                        align: 'right',
                        default: true
                    },
                    {
                        id: 'medianSide',
                        header: '中间边',
                        field: 'medianSide',
                        minWidth: '80px',
                        sortable: true,
                        align: 'right',
                        default: true
                    },
                    {
                        id: 'shortestSide',
                        header: '短边',
                        field: 'shortestSide',
                        minWidth: '80px',
                        sortable: true,
                        align: 'right',
                        default: true
                    },
                    {
                        id: 'weight',
                        header: '重量',
                        field: 'weight',
                        minWidth: '80px',
                        sortable: true,
                        align: 'right',
                        default: true
                    },
                    {id: 'weightUnits', header: '重量单位', field: 'weightUnits', minWidth: '80px', default: true},
                    {
                        id: 'itemVolume',
                        header: '体积',
                        field: 'itemVolume',
                        minWidth: '80px',
                        sortable: true,
                        align: 'right',
                        default: true
                    },
                    {id: 'volumeUnits', header: '体积单位', field: 'volumeUnits', minWidth: '80px', default: true},
                    {id: 'productSizeTier', header: '产品标准', field: 'productSizeTier', minWidth: '110px', default: true},
                    {
                        id: 'averageQuantityOnHand',
                        header: '库存量',
                        field: 'averageQuantityOnHand',
                        minWidth: '80px',
                        sortable: true,
                        align: 'right',
                        default: true
                    },
                    {
                        id: 'averageQuantityPendingRemoval',
                        header: '待移除数',
                        field: 'averageQuantityPendingRemoval',
                        minWidth: '90px',
                        sortable: true,
                        align: 'right',
                        default: true
                    },
                    {
                        id: 'estimatedTotalItemVolume',
                        header: '总体积',
                        field: 'estimatedTotalItemVolume',
                        minWidth: '80px',
                        sortable: true,
                        align: 'right',
                        default: true
                    },
                    {
                        id: 'storageRate',
                        header: '收费标准',
                        field: 'storageRate',
                        minWidth: '100px',
                        sortable: true,
                        align: 'right',
                        default: true
                    },
                    {id: 'currency', header: '币种', field: 'currency', minWidth: '80px', default: true},
                    {
                        id: 'estimatedMonthlyStorageFee',
                        header: '预估仓储费',
                        field: 'estimatedMonthlyStorageFee',
                        minWidth: '110px',
                        sortable: true,
                        align: 'right',
                        default: true
                    }
                ],
                tableData: [],
                filter: {
                    marketIds: [],
                    month: "",
                    categoryIds: [],
                    keyword: {
                        key: 'msku',
                        value: null
                    },
                    brandIds: [],
                },
                modalVisible: {
                    logModal: false,
                    detailModal: false,
                    clickDownload: false,
                },
                cacheOptions: {
                    useCache: true,
                }
            }
        },
        created() {
            this.sort.prop = null;
        },
        methods: {
            $gjQueryInitParams() {
                return {
                    filter: {
                        marketIds: [],
                        month: '',
                        keyword: {
                            key: 'msku', value: null
                        },
                        categoryIds: [],
                        brandIds: []
                    },
                };
            },
            /**
             *
             * @param params 查询条件参数
             * @override queryMixin
             * @returns {{ marketIds: *}}
             */
            $gjCacheCallback(params) {
                return {
                    marketIds: params.marketIds,
                };
            },
            $gjQuery() {
                // 构造查询参数
                const params = {
                    model: {
                        marketIds: this.filter.marketIds,
                        month: isMeaningful(this.filter.month) ?  convertToMonth(this.filter.month) : null,
                        categoryIds: this.filter.categoryIds,
                        brandIds: this.filter.brandIds
                    },
                    ...this.queryPagination,
                    ...this.querySort
                };
                params.model[this.filter.keyword.key] = this.filter.keyword.value;
                this.globalParams = params;
                // 查询
                this.loading = true;
                getStorageFeePage(params)
                    .then((data) => {
                        if (isMeaningful(data)) {
                            this.tableData = data.records;

                            this.pagination = this.getPagination(data);
                        }
                    })
                    .complete(() => {
                        this.loading = false;
                    })
            },
            download() {
                exportStorageFee(this.globalParams);
            }
        },
    }
</script>

<style scoped>

</style>
